<template>
    <modal title="YourParkingSpace Booking Guarantee" close-button-text="Done" image="/images/booking-guarantee-modal.png">
        <div slot="header">
            <h4>
                <img class="header-image" src="/images/shield.png" alt="Guarantee Shield">
                <template v-if="!$isWhitelabel && !isMicrosite">YourParkingSpace</template>
                <template v-else>Our</template>
                Booking Guarantee
            </h4>
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div slot="body">
            <p class="mb-4">
                We’re always confident that our prices are the best around, so we offer a Best Price Guarantee.
                We guarantee that you will never pay more to pre-book your parking via YourParkingSpace.
                In the unlikely event that you find a lower price for the same parking space elsewhere within 24 hours,
                we will match the lower rate and give you 20% off the competitor’s rate.
            </p>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal';
    import Microsite from '../mixins/Microsite';

    export default {
        name: 'booking-guarantee-modal',

        components: {
            Modal,
        },

        mixins: [Microsite],

        data() {
            return {};
        },

        mounted() {
            window.bus
                .$off('showBookingGuarantee')
                .$on('showBookingGuarantee', () => {
                    this.showModal();
                });
        },

        methods: {
            /**
             * Show the modal
             */
            showModal() {
                $(this.$el).modal('show');
            },
        },
    };
</script>

<style lang="less">
    #booking-guarantee-modal {
        .modal-dialog {
            .modal-content {
                position: relative;
            }
            h4 {
                font-size: 21px;
                margin-bottom: 20px;

                .header-image {
                    max-width: 22px;
                    margin-right: 10px;
                    margin-top: -4px;
                }
            }
        }
    }
</style>
